import {
  MemberPositionHistory,
  PositionAssignment,
  PositionAssignmentStatus,
} from '@core/tellent-positions-types';

// The endpoint answers oldest first; previous positions read newest first.
export function buildMemberPositionHistory(
  assignments: PositionAssignment[],
): MemberPositionHistory {
  return {
    scheduled: assignments.filter(item => item.status === PositionAssignmentStatus.Scheduled),
    current: assignments.find(item => item.status === PositionAssignmentStatus.Current) ?? null,
    previous: assignments.filter(item => item.status === PositionAssignmentStatus.Past).reverse(),
  };
}
